import { useField, useFormikContext } from "formik";
import React, { useEffect } from "react";

import { Column, Row } from "@gamedev-web/gamedev-sdk-core";
import { BasicMultilineTextInput } from "@gaming/xds-react-js";

import * as commonStyles from "../commonStyles/commonStyles.module.css";
import { FieldErrorMessage } from "../FieldErrorMessage";
import { FieldHeader, FieldHeaderProps, FieldStateProps } from "../FieldHeader";
import { ReadOnlyTextField } from "../ReadOnlyTextField/ReadOnlyTextField";
import { useSetFieldTouched } from "../useSetFieldTouched";

export type CustomMultiLineTextFieldProps = Readonly<{
  name: string;
  largeTextBox?: boolean;
  parentChecked?: boolean;
  maxLength?: number;
  maxLengthsByFieldName?: Record<string, number>;
}> &
  FieldHeaderProps &
  FieldStateProps;

export const CustomMultiLineTextField = (props: CustomMultiLineTextFieldProps) => {
  const [field] = useField(props);
  const { disabled, largeTextBox, parentChecked, maxLengthsByFieldName, maxLength } = props;
  useSetFieldTouched(field.name);
  const { setFieldValue } = useFormikContext();

  const [nameField] = useField({
    name: props.name,
  });

  useEffect(() => {
    if (parentChecked === false && field.value !== "") {
      setFieldValue(field.name, "");
    }
  }, [field.name, field.value, nameField, parentChecked, setFieldValue]);

  let forceMaxLengthByFieldName: undefined | number;
  if (maxLengthsByFieldName) {
    forceMaxLengthByFieldName = maxLengthsByFieldName[field.name];
  }

  return (
    <Row className={commonStyles.container}>
      <Column>
        <FieldHeader {...props} titleClassName={commonStyles.textFieldLabel} />
        {disabled && <ReadOnlyTextField name={field.name} />}
        {!disabled && (
          <BasicMultilineTextInput
            id={field.name}
            name={field.name}
            value={field.value ?? ""}
            onChange={field.onChange}
            onBlur={field.onBlur}
            data-testid={field.name}
            aria-label={props.title}
            className={commonStyles.textFieldMultilineWrapper}
            inputClassName={
              largeTextBox ? commonStyles.largeTextBox : commonStyles.textFieldMultiline
            }
            disabled={props.isSaving || parentChecked === false}
            maxLength={maxLength ? maxLength : forceMaxLengthByFieldName}
          />
        )}
        <FieldErrorMessage fieldName={field.name} />
      </Column>
    </Row>
  );
};
